import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-yellow",
  "use": "icon-check-yellow-usage",
  "viewBox": "0 0 19 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 13\" id=\"icon-check-yellow\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.917 4.666L6.157 9.3 17.259 0 19 2.078 5.963 13 0 6.731z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol